"use client";
import React from "react";
import { MenuItem } from "@/types/models";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@pulsex/utils";

// this function is used to clean up strings from special characters (eg '%20','-'...) in order to compare them
const normalize = (str: string) => {
    return decodeURIComponent(str)
        .toLowerCase()
        .replace(/[\s\-]/g, "")
        .replace(/[%]/g, "");
};

const SecondaryMenu = ({ items }: { items?: MenuItem[] }) => {
    const pathname = usePathname();
    if (!items?.length) return null;

    // get the last element in the path (region) (eg africa, asia...)
    const arrayAsPath = pathname.split('/').filter(e => e !== '/')
    const lastElement = arrayAsPath[arrayAsPath.length - 1]

    return (
        <div className="w-full shadow-md h-[53px] bg-primary text-white lg:hidden">
            <div className="container mx-auto">
                <div className="flex justify-between items-center font-medium py-4 px-1">
                    {items.map((link) => {
                        const isActive = normalize(lastElement) === normalize(link.title);
                        return (
                            <React.Fragment key={link.title}>
                                <Link
                                    href={link.url}
                                    className={cn(
                                        "text-[15px] relative w-full text-center border-r-2 last:border-r-0 border-white/70",
                                        isActive && "text-primary font-bold border-r-0"
                                    )}
                                >
                                    {isActive && (
                                        <span className="absolute top-1/2 left-0 -translate-y-[calc(50%+1px)] w-full h-[54px] bg-white" />
                                    )}
                                    <span className="relative z-10">{link.title}</span>
                                </Link>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SecondaryMenu;
